export enum EnumType {
    Permission = 'Permission',
    UserStatus = 'UserStatus',
    PayorCategory = 'PayorCategory',
    UserType = 'UserType',
    OrderStatus = 'OrderStatus',
    DisplayOption = 'DisplayOption',
    CommercialOrderStatus = 'CommercialOrderStatus',
    EventBillingMethod = 'EventBillingMethod',
    EventSampleCollectionMethod = 'EventSampleCollectionMethod',
    EventSampleCollectionType = 'EventSampleCollectionType',
    Restrictions = '1FBB16D3-6D17-4C07-9AAE-D006E8D1A7AC',
    Race = 'Race',
    Ethnicity = 'Ethnicity',
    EventType = 'EventType',
    BillingType = 'BillingType',
    ShipperType = 'ShipperType'
}
